<!--
Für die Anzeige von Barcodes muss vue-barcode installiert sein:
    npm install @chenfengyuan/vue-barcode
-->
<template>
    <v-container class="spare-parts-container">
        <v-row justify="center">
            <v-col cols="12">
                <v-card class="status-overview-card mb-6">
                    <v-card-title class="d-flex align-center">
                        <v-icon color="primary" size="24" class="mr-2">mdi-package-variant</v-icon>
                        Ersatzteil anlegen
                    </v-card-title>
                    <v-divider class="card-divider"></v-divider>
                    <v-card-text class="py-4">
                        <v-form @submit.prevent="addSparePart" ref="formRef" v-model="formValid">
                            <v-select
                                v-model="form.modelId"
                                :items="modelOptions"
                                item-title="name"
                                item-value="id"
                                label="Modell"
                                :rules="[v => !!v || 'Modell erforderlich']"
                                required
                                variant="outlined"
                                bg-color="rgba(30, 30, 40, 0.5)"
                                class="form-field"
                                color="success"
                            >
                                <template #append-item>
                                    <v-divider></v-divider>
                                    <v-list-item @click="showAddModelDialog = true">
                                        <v-icon left>mdi-plus</v-icon>
                                        Modell hinzufügen
                                    </v-list-item>
                                </template>
                            </v-select>
                            <v-text-field
                                v-model="form.barcode"
                                label="Barcode-Nummer"
                                :rules="[v => !!v || 'Barcode erforderlich']"
                                required
                                variant="outlined"
                                bg-color="rgba(30, 30, 40, 0.5)"
                                class="form-field"
                                color="success"
                            />
                            <v-text-field
                                v-model="form.label"
                                label="Bezeichnung"
                                :rules="[v => !!v || 'Bezeichnung erforderlich']"
                                required
                                variant="outlined"
                                bg-color="rgba(30, 30, 40, 0.5)"
                                class="form-field"
                                color="success"
                            />
                            <v-btn
                                type="submit"
                                color="success"
                                :disabled="!formValid"
                                class="mt-6 submit-btn"
                                block
                                size="large"
                                elevation="2"
                            >
                                <v-icon start>mdi-content-save</v-icon>
                                Speichern
                            </v-btn>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col cols="12">
                <v-card class="status-overview-card">
                    <v-card-title class="d-flex align-center">
                        <v-icon color="primary" size="24" class="mr-2">mdi-format-list-checks</v-icon>
                        Gespeicherte Ersatzteile
                    </v-card-title>
                    <v-divider class="card-divider"></v-divider>
                    <v-card-text class="py-4">
                        <div v-for="(parts, modelName) in spareParts" :key="modelName" class="category-group">
                            <div class="category-header d-flex align-center mb-4">
                                <span class="category-title">{{ modelName }}</span>
                                <v-spacer></v-spacer>
                                <v-btn icon color="success" @click="printCategory(modelName)" class="action-btn">
                                    <v-icon>mdi-printer</v-icon>
                                </v-btn>
                                <v-btn icon color="success" @click="openEditModelDialog(modelName)" class="action-btn">
                                    <v-icon>mdi-pencil</v-icon>
                                </v-btn>
                                <v-btn icon color="error" @click="openDeleteModelDialog(modelName)" class="action-btn">
                                    <v-icon>mdi-delete</v-icon>
                                </v-btn>
                            </div>
                            <v-row>
                                <v-col
                                    v-for="part in parts"
                                    :key="part.id"
                                    cols="12" md="6" lg="4"
                                >
                                    <v-card class="spare-part-card">
                                        <v-card-text>
                                            <div class="spare-part-barcode">
                                                <vue-barcode :value="part.barcode" :width="2" :height="60" :display-value="false" />
                                            </div>
                                            <div class="spare-part-barcode-number">{{ part.barcode }}</div>
                                            <div class="spare-part-label">{{ part.label }}</div>
                                        </v-card-text>
                                        <v-card-actions class="action-buttons">
                                            <v-btn icon color="success" @click="openEditSparePartDialog(part)" class="action-btn">
                                                <v-icon>mdi-pencil</v-icon>
                                            </v-btn>
                                            <v-btn icon color="error" @click="openDeleteSparePartDialog(part)" class="action-btn">
                                                <v-icon>mdi-delete</v-icon>
                                            </v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <!-- Modell hinzufügen Dialog -->
        <v-dialog v-model="showAddModelDialog" max-width="400" class="edit-dialog">
            <v-card class="dialog-card">
                <v-card-title class="dialog-title d-flex align-center">
                    <v-icon color="success" size="24" class="mr-2">mdi-plus-circle</v-icon>
                    Neues Modell anlegen
                </v-card-title>
                <v-divider class="dialog-divider"></v-divider>
                <v-card-text class="dialog-content py-4">
                    <v-text-field
                        v-model="newModelName"
                        label="Modellname"
                        required
                        variant="outlined"
                        bg-color="rgba(30, 30, 40, 0.5)"
                        class="form-field"
                        color="success"
                    />
                </v-card-text>
                <v-divider class="dialog-divider"></v-divider>
                <v-card-actions class="dialog-actions">
                    <v-btn color="grey" variant="text" @click="showAddModelDialog = false">Abbrechen</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="success" variant="elevated" @click="addModel">
                        <v-icon start>mdi-content-save</v-icon>
                        Speichern
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Modell bearbeiten Dialog -->
        <v-dialog v-model="showEditModelDialog" max-width="400" class="edit-dialog">
            <v-card class="dialog-card">
                <v-card-title class="dialog-title d-flex align-center">
                    <v-icon color="success" size="24" class="mr-2">mdi-pencil-box</v-icon>
                    Modell umbenennen
                </v-card-title>
                <v-divider class="dialog-divider"></v-divider>
                <v-card-text class="dialog-content py-4">
                    <v-text-field
                        v-model="editModelName"
                        label="Neuer Modellname"
                        required
                        variant="outlined"
                        bg-color="rgba(30, 30, 40, 0.5)"
                        class="form-field"
                        color="success"
                    />
                </v-card-text>
                <v-divider class="dialog-divider"></v-divider>
                <v-card-actions class="dialog-actions">
                    <v-btn color="grey" variant="text" @click="showEditModelDialog = false">Abbrechen</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="success" variant="elevated" @click="updateModel">
                        <v-icon start>mdi-content-save</v-icon>
                        Speichern
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Modell löschen Dialog -->
        <v-dialog v-model="showDeleteModelDialog" max-width="400" class="delete-dialog">
            <v-card class="dialog-card">
                <v-card-title class="dialog-title warning-header d-flex align-center">
                    <v-icon color="error" size="24" class="mr-2">mdi-alert-circle</v-icon>
                    Modell löschen
                </v-card-title>
                <v-divider class="dialog-divider"></v-divider>
                <v-card-text class="dialog-content text-center pa-6">
                    <p>Möchtest du das Modell <b>{{ editModelName }}</b> wirklich löschen?</p>
                    <p class="text-caption mt-2">Diese Aktion kann nicht rückgängig gemacht werden.</p>
                </v-card-text>
                <v-divider class="dialog-divider"></v-divider>
                <v-card-actions class="dialog-actions">
                    <v-btn color="grey" variant="text" @click="showDeleteModelDialog = false">Abbrechen</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="error" variant="elevated" @click="deleteModel">
                        <v-icon start>mdi-delete</v-icon>
                        Löschen
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Ersatzteil bearbeiten Dialog -->
        <v-dialog v-model="showEditSparePartDialog" max-width="500" class="edit-dialog">
            <v-card class="dialog-card">
                <v-card-title class="dialog-title d-flex align-center">
                    <v-icon color="success" size="24" class="mr-2">mdi-pencil-box</v-icon>
                    Ersatzteil bearbeiten
                </v-card-title>
                <v-divider class="dialog-divider"></v-divider>
                <v-card-text class="dialog-content py-4">
                    <v-select
                        v-model="editSparePart.model_id"
                        :items="modelOptions"
                        item-title="name"
                        item-value="id"
                        label="Modell"
                        required
                        variant="outlined"
                        bg-color="rgba(30, 30, 40, 0.5)"
                        class="form-field"
                        color="success"
                    />
                    <v-text-field
                        v-model="editSparePart.barcode"
                        label="Barcode-Nummer"
                        required
                        variant="outlined"
                        bg-color="rgba(30, 30, 40, 0.5)"
                        class="form-field"
                        color="success"
                    />
                    <v-text-field
                        v-model="editSparePart.label"
                        label="Bezeichnung"
                        required
                        variant="outlined"
                        bg-color="rgba(30, 30, 40, 0.5)"
                        class="form-field"
                        color="success"
                    />
                </v-card-text>
                <v-divider class="dialog-divider"></v-divider>
                <v-card-actions class="dialog-actions">
                    <v-btn color="grey" variant="text" @click="showEditSparePartDialog = false">Abbrechen</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="success" variant="elevated" @click="updateSparePart">
                        <v-icon start>mdi-content-save</v-icon>
                        Speichern
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Ersatzteil löschen Dialog -->
        <v-dialog v-model="showDeleteSparePartDialog" max-width="400" class="delete-dialog">
            <v-card class="dialog-card">
                <v-card-title class="dialog-title warning-header d-flex align-center">
                    <v-icon color="error" size="24" class="mr-2">mdi-alert-circle</v-icon>
                    Ersatzteil löschen
                </v-card-title>
                <v-divider class="dialog-divider"></v-divider>
                <v-card-text class="dialog-content text-center pa-6">
                    <p>Möchtest du das Ersatzteil <b>{{ editSparePart.label }}</b> wirklich löschen?</p>
                    <p class="text-caption mt-2">Diese Aktion kann nicht rückgängig gemacht werden.</p>
                </v-card-text>
                <v-divider class="dialog-divider"></v-divider>
                <v-card-actions class="dialog-actions">
                    <v-btn color="grey" variant="text" @click="showDeleteSparePartDialog = false">Abbrechen</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="error" variant="elevated" @click="deleteSparePart">
                        <v-icon start>mdi-delete</v-icon>
                        Löschen
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script setup lang="ts">
import { ref, onMounted, defineComponent } from 'vue';
import axios from 'axios';
import { API_BASE_URL } from '@/config';
import VueBarcode from '@chenfengyuan/vue-barcode';

defineComponent({
    components: { VueBarcode }
});

const form = ref({
    modelId: '',
    barcode: '',
    label: '',
});
const formValid = ref(false);
const formRef = ref();
const spareParts = ref<Record<string, any[]>>({});
const modelOptions = ref<{ id: number; name: string }[]>([]);
const showAddModelDialog = ref(false);
const newModelName = ref('');

// Edit/Delete State
const showEditModelDialog = ref(false);
const showDeleteModelDialog = ref(false);
const editModelId = ref<number|null>(null);
const editModelName = ref('');

const showEditSparePartDialog = ref(false);
const showDeleteSparePartDialog = ref(false);
const editSparePart = ref<any>({});

const fetchModels = async () => {
    const res = await axios.get(`${API_BASE_URL}sparepart_models.php`, {
        params: { action: 'list' },
        withCredentials: true
    });
    if (res.data.status === 'success') {
        modelOptions.value = res.data.models;
    }
};

const fetchSpareParts = async () => {
    const res = await axios.get(`${API_BASE_URL}spareparts.php`, {
        params: { action: 'list' },
        withCredentials: true
    });
    if (res.data.status === 'success') {
        spareParts.value = res.data.spareparts;
    }
};

const addSparePart = async () => {
    if (!formValid.value) return;
    const payload = {
        model_id: form.value.modelId,
        barcode: form.value.barcode,
        label: form.value.label,
    };
    const res = await axios.post(`${API_BASE_URL}spareparts.php`, payload, { withCredentials: true });
    if (res.data.status === 'success') {
        fetchSpareParts();
        form.value = { modelId: '', barcode: '', label: '' };
        if (formRef.value) formRef.value.resetValidation();
    }
};

const addModel = async () => {
    if (!newModelName.value.trim()) return;
    const res = await axios.post(`${API_BASE_URL}sparepart_models.php`, { name: newModelName.value.trim() }, { withCredentials: true });
    if (res.data.status === 'success') {
        fetchModels();
        showAddModelDialog.value = false;
        newModelName.value = '';
    }
};

// Edit/Delete Methoden für Modelle
const openEditModelDialog = (modelName: string) => {
    const model = modelOptions.value.find(m => m.name === modelName);
    if (model) {
        editModelId.value = model.id;
        editModelName.value = model.name;
        showEditModelDialog.value = true;
    }
};
const updateModel = async () => {
    if (!editModelId.value || !editModelName.value.trim()) return;
    await axios.put(`${API_BASE_URL}sparepart_models.php`, { id: editModelId.value, name: editModelName.value.trim() }, { withCredentials: true });
    showEditModelDialog.value = false;
    fetchModels();
    fetchSpareParts();
};
const openDeleteModelDialog = (modelName: string) => {
    const model = modelOptions.value.find(m => m.name === modelName);
    if (model) {
        editModelId.value = model.id;
        editModelName.value = model.name;
        showDeleteModelDialog.value = true;
    }
};
const deleteModel = async () => {
    if (!editModelId.value) return;
    await axios.delete(`${API_BASE_URL}sparepart_models.php`, { data: { id: editModelId.value }, withCredentials: true });
    showDeleteModelDialog.value = false;
    fetchModels();
    fetchSpareParts();
};

// Edit/Delete Methoden für Ersatzteile
const openEditSparePartDialog = (part: any) => {
    editSparePart.value = { ...part };
    showEditSparePartDialog.value = true;
};
const updateSparePart = async () => {
    if (!editSparePart.value.id || !editSparePart.value.model_id || !editSparePart.value.barcode || !editSparePart.value.label) return;
    await axios.put(`${API_BASE_URL}spareparts.php`, {
        id: editSparePart.value.id,
        model_id: editSparePart.value.model_id,
        barcode: editSparePart.value.barcode,
        label: editSparePart.value.label,
    }, { withCredentials: true });
    showEditSparePartDialog.value = false;
    fetchSpareParts();
};
const openDeleteSparePartDialog = (part: any) => {
    editSparePart.value = { ...part };
    showDeleteSparePartDialog.value = true;
};
const deleteSparePart = async () => {
    if (!editSparePart.value.id) return;
    await axios.delete(`${API_BASE_URL}spareparts.php`, { data: { id: editSparePart.value.id }, withCredentials: true });
    showDeleteSparePartDialog.value = false;
    fetchSpareParts();
};

const printCategory = (modelName: string) => {
    const parts = spareParts.value[modelName] || [];
    const printWindow = window.open('', '', 'width=800,height=600');
    if (!printWindow) return;

    let html = `
        <html>
        <head>
            <title>${modelName}</title>
            <style>
                body {
                    font-family: Arial, sans-serif;
                    margin: 0;
                    padding: 20px;
                    background: white;
                }
                .header {
                    text-align: center;
                    margin-bottom: 30px;
                    padding-bottom: 10px;
                    border-bottom: 2px solid #4caf50;
                }
                .header h2 {
                    color: #333;
                    margin: 0;
                    font-size: 24px;
                }
                .parts-grid {
                    display: grid;
                    grid-template-columns: repeat(3, 1fr);
                    gap: 30px;
                    padding: 20px;
                }
                .part-item {
                    text-align: center;
                    padding: 15px;
                    border: 1px solid #ddd;
                    border-radius: 8px;
                    background: white;
                }
                .barcode {
                    margin: 10px 0;
                }
                .barcode img {
                    max-width: 100%;
                    height: auto;
                }
                .label {
                    font-size: 16px;
                    font-weight: bold;
                    color: #333;
                    margin-top: 10px;
                }
                @media print {
                    body {
                        padding: 0;
                    }
                    .parts-grid {
                        gap: 20px;
                        padding: 10px;
                    }
                    .part-item {
                        break-inside: avoid;
                        page-break-inside: avoid;
                    }
                }
            </style>
        </head>
        <body>
            <div class="header">
                <h2>${modelName}</h2>
            </div>
            <div class="parts-grid">
    `;

    for (const part of parts) {
        html += `
            <div class="part-item">
                <div class="barcode">
                    <img src="https://barcode.tec-it.com/barcode.ashx?data=${encodeURIComponent(part.barcode)}&code=Code128&translate-esc=false" />
                </div>
                <div class="label">${part.label}</div>
            </div>
        `;
    }

    html += `
            </div>
        </body>
        </html>
    `;

    printWindow.document.write(html);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
};

onMounted(() => {
    fetchModels();
    fetchSpareParts();
});
</script>

<style scoped>
/* ======== Container & Basis-Layout ======== */
.spare-parts-container {
    max-width: 1200px;
    margin: 0 auto;
    padding-top: 24px;
    padding-bottom: 32px;
}

/* ======== Karten & Container ======== */
.status-overview-card {
    background-color: rgba(30, 30, 35, 0.7);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 12px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    margin-bottom: 24px;
    transition: all 0.3s ease;
}

.card-divider {
    opacity: 0.1;
}

.dialog-card {
    background-color: rgba(30, 30, 35, 0.9);
    backdrop-filter: blur(15px);
    -webkit-backdrop-filter: blur(15px);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 12px;
    overflow: hidden;
}

.dialog-title {
    padding: 16px;
    font-size: 1.1rem;
    font-weight: 500;
    background: linear-gradient(120deg, rgba(255,255,255,0.03), rgba(255,255,255,0.01));
    border-bottom: 1px solid rgba(255,255,255,0.05);
}

.dialog-divider {
    opacity: 0.1;
}

.dialog-content {
    padding: 20px;
}

.dialog-actions {
    padding: 12px 16px;
}

.warning-header {
    background: rgba(var(--v-theme-error), 0.1);
}

/* ======== Eingabefelder & Formulare ======== */
.form-field {
    margin-bottom: 12px;
}

.form-field :deep(.v-field__input) {
    color: rgba(255, 255, 255, 0.85);
}

.form-field :deep(.v-field__outline) {
    color: rgba(255, 255, 255, 0.12);
}

.form-field :deep(.v-field:hover .v-field__outline) {
    color: rgba(255, 255, 255, 0.18);
}

.submit-btn {
    height: 50px;
    border-radius: 12px !important;
    font-weight: 500;
    letter-spacing: 0.5px;
    text-transform: none;
    box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3) !important;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
}

.submit-btn[disabled] {
    opacity: 0.65 !important;
    box-shadow: none !important;
    background-color: rgba(60, 60, 60, 0.8) !important;
    color: rgba(255, 255, 255, 0.5) !important;
}

.submit-btn::before {
    content: "";
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
    transition: 0.6s;
}

.submit-btn:hover:not([disabled]) {
    transform: translateY(-2px);
    box-shadow: 0 6px 15px rgba(76, 175, 80, 0.4) !important;
}

.submit-btn:hover:not([disabled])::before {
    left: 100%;
}

/* ======== Kategorien & Ersatzteile ======== */
.category-group {
    margin-bottom: 32px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    padding-bottom: 16px;
}

.category-header {
    font-size: 1.2em;
    font-weight: 600;
    margin-bottom: 8px;
}

.category-title {
    font-size: 1.1em;
    font-weight: 700;
    color: #4caf50;
}

.spare-part-card {
    min-height: 180px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background-color: rgba(30, 30, 35, 0.7);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    border: 1px solid rgba(255,255,255,0.08);
    border-radius: 12px;
    box-shadow: 0 4px 16px rgba(0,0,0,0.08);
    margin-bottom: 16px;
    transition: all 0.3s ease;
}

.spare-part-card:hover {
    box-shadow: 0 8px 32px rgba(76, 175, 80, 0.15);
    transform: translateY(-2px);
}

.spare-part-barcode {
    margin: 8px 0;
    display: flex;
    justify-content: center;
}

.spare-part-barcode-number {
    font-size: 1.1em;
    margin-bottom: 4px;
    text-align: center;
    color: rgba(255, 255, 255, 0.85);
}

.spare-part-label {
    font-size: 1.2em;
    font-weight: 600;
    text-align: center;
    color: rgba(255, 255, 255, 0.9);
}

/* ======== Aktionsbuttons ======== */
.action-buttons {
    justify-content: flex-end;
    padding: 0 8px 8px 8px;
}

.action-btn {
    opacity: 0.8;
    transition: all 0.2s ease;
}

.action-btn:hover {
    opacity: 1;
    transform: translateY(-2px);
}

/* ======== Responsive Anpassungen ======== */
@media (max-width: 960px) {
    .spare-parts-container {
        padding-top: 16px;
        padding-bottom: 24px;
    }
}

@media (max-width: 600px) {
    .dialog-content {
        padding: 16px;
    }

    .dialog-title {
        font-size: 1rem;
        padding: 12px 16px;
    }

    .category-title {
        font-size: 1em;
    }

    .spare-part-label {
        font-size: 1.1em;
    }
}
</style>
